export default __webpack_public_path__ + "static/media/no_image.30b956d7.jpg";